import GetUsers from "./GetUsers";
import axios from "axios";
const fireBaseUsersUri =
  "https://login-app-01-01-default-rtdb.firebaseio.com/users.json";

const RegisterUser = async (
  authCtx,
  userData
) => {
  const registerCtx = authCtx;
  registerCtx.onSaveRegisterState(
    true, //isLoading
    false, //error
    "" //reply
  );

  try {
    const Users = await GetUsers(
      fireBaseUsersUri,
      userData.emailAddress
    );
    if (!Users) {
      const { data } = await axios.post(
        "https://login-app-01-01-default-rtdb.firebaseio.com/users.json",
        JSON.stringify(userData)
      );
      registerCtx.onSaveRegisterState(
        false, //isLoading
        false, //error
        "User registered successfully" //reply
      );
      setTimeout(() => {
        registerCtx.onSaveRegisterState(
          false, //isLoading
          false, //error
          "" //reply
        );
        registerCtx.onSignUp(false);
      }, 1000);

      return data;
    } else {
      registerCtx.onSaveEmailExist(
        true,
        userData.emailAddress
      );

      registerCtx.onSaveRegisterState(
        false, //isLoading
        false, //error
        "" //reply
      );
    }
  } catch (error) {
    console.log(error.message);
    registerCtx.onSaveRegisterState(
      false, //isLoading
      true, //error
      error.message //reply
    );
  }
};

export default RegisterUser;
